import styled from 'styled-components';
import { Link as GLink } from 'gatsby';

const colorTheme = {
  secondary: '#1b7bdd',
  red: '#ce445b',
  green: '#1ba39c',
};

export const Link = styled(GLink)`
  &:hover {
    text-decoration: underline;
  }

  &.home_link {
    p {
      margin-bottom: 0px;
      color: #000;
      transition: 0.3s;
    }

    right: ${({ dir }) => (dir === 'rtl' ? '' : '')};
    left: ${({ dir }) => (dir === 'rlt' ? '0px' : '')};

    &:hover {
      color: ${({ color }) => colorTheme[color]};

      p {
        color: ${({ color }) => colorTheme[color]};
      }
    }

    .arrow {
      width: 14px;
      height: 10px;
      margin-left: 5px;
    }
  }

  &.latest_news_link {
    @media (max-width: 767.98px) {
      display: none;
    }
  }
`;
